import { get } from "lodash";
import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Segment, Header } from "semantic-ui-react";
import { Formik, Form } from "formik";

import * as Yup from "yup";
import { sshTableValidationSchema } from "../sshKeys/sshTableValidationSchemas.js";

import SSHTable from "../sshKeys/SSHTable.jsx";
import FormikActionsPanel from "../forms/formik/FormikActionsPanel.jsx";

class SSHKeyForm extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    onReset: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onFormikSubmit: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired,
    violationErrors: PropTypes.object,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    disabled: false,
    copyKey: "account.ssh_keys"
  };

  constructor(props) {
    super(props);

    const sshKeys = get(props, "data.sshKeys", null);

    this.state = {
      initialValues: {
        sshKeys: sshKeys || []
      }
    };
  }

  static getDerivedStateFromProps = (props, state) => {
    const sshKeys = get(props, "data.sshKeys", "") || [];

    if (sshKeys !== state.initialValues.sshKeys) {
      return { initialValues: { sshKeys } };
    }

    return null;
  };

  // -- VALIDATION -- //

  validationSchema = function () {
    const messages = this.props.copy("forms.validation_requirements");

    return Yup.object().shape({
      sshKeys: sshTableValidationSchema(messages)
    });
  };

  // -- RENDER -- //

  render() {
    const {
      onReset,
      onSubmit,
      onFormikSubmit,
      violationErrors,
      copyKey,
      copy
    } = this.props;

    return (
      <Segment vertical padded textAlign="left">
        <Header as="h3">{copy(`${copyKey}.title`)}</Header>
        <Formik
          initialValues={this.state.initialValues}
          validateOnMount={true}
          enableReinitialize={true}
          validationSchema={this.validationSchema()}
          onSubmit={onFormikSubmit}
        >
          {formikProps => {
            return (
              <Form className="ui form">
                <p className="float-left">{copy(`${copyKey}.body`)}</p>
                <SSHTable
                  id="sshKeys"
                  disabled={false}
                  formikProps={formikProps}
                  showIsUsed={true}
                  showApplyExisting={false}
                  showNotRequired={false}
                  showActionsTop={false}
                  apiErrors={violationErrors}
                />
                <FormikActionsPanel
                  reset={true}
                  onReset={onReset}
                  submit={true}
                  useSubmitModal={true}
                  onSubmit={onSubmit}
                  modalCopy={copy(`account.modals`)}
                />
              </Form>
            );
          }}
        </Formik>
      </Segment>
    );
  }
}

export default SSHKeyForm;
